module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0092.41b132d9.jpg";